import { render, staticRenderFns } from "./ProfileManager.vue?vue&type=template&id=38c1ffdb&lang=pug&"
import script from "./ProfileManager.vue?vue&type=script&lang=ts&"
export * from "./ProfileManager.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileManager.vue?vue&type=style&index=0&id=38c1ffdb&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports